(function () {
    'use strict';

    angular.module('doclr.activiteiten', ['doclr.resources.api', 'doclr.components.notification', 'doclr.components.colorselector', 'ui.router', 'doclr.disciplines'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('activiteiten', {
                    url: '/activiteiten/:typeId',

                    resolve: {
                        disciplineList: function (Disciplines) {
                            return Disciplines.getList();
                        },
                        producten: function (IpdcProducten, praktijkContext) {
                            return IpdcProducten.getList(praktijkContext.id).then(function (producten) {
                                return _.sortBy(producten, function (ipdcProduct) {
                                    if (ipdcProduct.product.naam && ipdcProduct.product.naam.nl) {
                                        return ipdcProduct.product.naam && ipdcProduct.product.naam.nl;
                                    }
                                    return "niet gekend";

                                });
                            });
                        },
                        types: function (EditableBeschikbaarheidTypes, praktijkContext) {
                            return EditableBeschikbaarheidTypes.getList(praktijkContext.id).then(function (types) {
                                return _.sortBy(types, function (type) {
                                    return type.editeerbaar ? 0 : 1;
                                });
                            });
                        },
                        type: function ($stateParams, EditableBeschikbaarheidTypes, types, praktijkContext) {
                            var standaardAdresId = praktijkContext.adressen.filter(function (adres) {
                                return adres.standaard;
                            })[0].id;
                            if ($stateParams.typeId === 'nieuw' || types.length === 0) {
                                return {
                                    eventType: 'afspraakMogelijkheid',
                                    zichtbaarVoorPatient: 'ja',
                                    editeerbaar: true,
                                    metAfspraakmogelijkheden: false,
                                    invulbaarDoorPatient: false,
                                    kleur: '#bee0f9',
                                    metEmail: false,
                                    praktijkAdresId: standaardAdresId,
                                    isActive: true
                                };
                            } else if ($stateParams.typeId) {
                                return EditableBeschikbaarheidTypes.load(decodeURIComponent(decodeURIComponent($stateParams.typeId)));
                            } else {
                                return EditableBeschikbaarheidTypes.load(types.filter(type => !!type.isActive).filter(type => type.eventType == 'afspraakMogelijkheid')[0].id);
                            }
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.large.margin.html',
                            controller: function ($scope, $state, $window) {
                                $scope.goToDetail = function (typeId) {
                                    $state.go('activiteiten', {typeId: typeId ? encodeURIComponent(encodeURIComponent(typeId)) : null}, {reload: true});
                                    $window.scroll({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                };
                            }
                        },
                        'sidebar@activiteiten': {
                            templateUrl: '/partials/beschikbaarheidtypes/activiteiten.sidebar.html',
                            controller: function ($scope, $state, types, type, borderColor, groupByKey, sortByProperty) {
                                $scope.showInactive = false;
                                $scope.types = types;
                                let activeTypes = types.filter(type => !!type.isActive)
                                    .filter(type => type.eventType == 'afspraakMogelijkheid');
                                let inactiveTypes = types.filter(type => !type.isActive);

                                $scope.groupedActiveTypes = groupAppointmentTypes(activeTypes);
                                $scope.groupedInActiveTypes = groupAppointmentTypes(inactiveTypes);

                                $scope.currentType = type;

                                $scope.isActiefType = function (type) {
                                    return $scope.currentType.id === type.id;
                                };

                                $scope.toggleInactiveTypes = () => $scope.showInactive = !$scope.showInactive;

                                $scope.borderColor = borderColor;

                                $scope.createNew = function () {
                                    $scope.goToDetail('nieuw');
                                };

                                function groupAppointmentTypes(appointmentTypes) {
                                    return groupByKey(appointmentTypes, (type) => type.disciplineName)
                                        .map(group => {
                                            return {
                                                disciplineName: group.key,
                                                types: group.values.sort(sortByProperty(x => doclrVertaal.translateType(x)))
                                            }
                                        })
                                        .sort(sortByProperty(x => x.disciplineName));
                                }
                            }
                        },
                        'content@activiteiten': {
                            templateUrl: '/partials/beschikbaarheidtypes/beschikbaarheidtypes.detail.html',
                            resolve: {
                                praktijk: function (Praktijk, praktijkContext) {
                                    return Praktijk.getInfo(praktijkContext.id);
                                },
                                mailOntvangers: function (EditableBeschikbaarheidTypes, praktijkContext, type) {
                                    return EditableBeschikbaarheidTypes.getMailOntvangers(type.id, praktijkContext.id);
                                }
                            },
                            controller: function ($state,
                                                  $scope,
                                                  disciplineList,
                                                  EditableBeschikbaarheidTypes,
                                                  notificationService,
                                                  praktijkContext,
                                                  appContext,
                                                  praktijk,
                                                  type,
                                                  $uibModal,
                                                  mailOntvangers,
                                                  supportedLanguages,
                                                  DoclrModalService,
                                                  $sce,
                                                  producten,
                                                  RichTextFactory) {
                                $scope.disciplineList = disciplineList;
                                $scope.appContext = appContext;
                                $scope.ipdcProductList = producten;
                                $scope.eventTypes = ['afspraakMogelijkheid', 'beschikbaarheid']
                                $scope.type = type;
                                $scope.praktijk = praktijk;
                                $scope.praktijkContext = praktijkContext;
                                $scope.isNieuwType = function () {
                                    return !$scope.type.id;
                                };
                                RichTextFactory.setIpdcProducts(producten);
                                $scope.makeDefault = function () {
                                    DoclrModalService.openConfirmModal(
                                        doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.make.default.popup.title'),
                                        doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.make.default.popup.question'))
                                        .then(() => EditableBeschikbaarheidTypes.setDefault(praktijkContext.id, type.id))
                                        .then(() => $scope.goToDetail(type.id));
                                }

                                $scope.mailTexts = [];
                                $scope.extraHtmlTexts = [];

                                $scope.translationKeys = {
                                    mailText: $scope.mailTexts,
                                    extraHtml: $scope.extraHtmlTexts
                                }

                                if (!$scope.isNieuwType()) {
                                    for (let language of supportedLanguages) {
                                        $scope.mailTexts.push(createTranslationItem(language, 'mailText'));
                                        $scope.extraHtmlTexts.push(createTranslationItem(language, 'extraHtml'));
                                    }
                                }

                                function createTranslationItem(language, key) {
                                    let value = getLanguage(language, key);
                                    let htmlValue = undefined;
                                    let parsedValue = undefined;
                                    try {
                                        parsedValue = JSON.parse(value);
                                        if (parsedValue) {
                                            htmlValue = parsedValue.rawHtml;
                                        }

                                    } catch (ex) {
                                    }

                                    return {
                                        language: language,
                                        value: parsedValue,
                                        hasTranslation: htmlValue && htmlValue.trim() !== '',
                                        toolTipValue: $sce.trustAsHtml(getTooltipValue(htmlValue, key)),
                                        translationKey: key
                                    };
                                }

                                function getLanguage(language, key) {
                                    if (type[key] && type[key][language] && type[key][language].trim() !== '') {
                                        return type[key][language];
                                    }
                                    return undefined;
                                }

                                function getTooltipValue(value, key) {
                                    return replacePlaceHolders(value) || doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.' + key + '.notset');
                                }

                                function replacePlaceHolders(value) {
                                    if (!value) {
                                        return value;
                                    }
                                    let newValue = value;
                                    findPlaceholders(value).forEach(placeHolder => {
                                        const parts = placeHolder.split(":");
                                        if (parts.length === 3) {
                                            const productHtml = producten.filter(x => x.id === parts[0])[0].product[parts[1]][parts[2]];
                                            newValue = newValue.replaceAll('{' + placeHolder + '}', productHtml);
                                        }
                                        if (parts.length === 5) {
                                            const productHtml = producten.filter(x => x.id === parts[0])[0].product[parts[1]]
                                                .filter(x => x.order + '' === parts[2])[0][parts[3]][parts[4]];
                                            newValue = newValue.replaceAll('{' + placeHolder + '}', productHtml);
                                        }

                                    });

                                    return newValue;


                                }

                                function findPlaceholders(value) {
                                    const placholders = []

                                    let start = value.indexOf("{");
                                    let nextSearch = value;
                                    while (start > -1) {
                                        var end = nextSearch.indexOf("}");
                                        if (end < 0) {
                                            return placholders;
                                        }

                                        placholders.push(nextSearch.substring(start + 1, end));

                                        nextSearch = nextSearch.substring(end + 1);
                                        start = nextSearch.indexOf("{");
                                    }
                                    return placholders;
                                }

                                $scope.editTranslationText = function (translationItem) {
                                    let translationItemClone = {
                                        language: translationItem.language,
                                        value: translationItem.value,
                                        translationKey: translationItem.translationKey,
                                        title: doclrVertaal.instant('beschaarheid.' + translationItem.translationKey.toLowerCase() + '.edit.title'),
                                        infoText: doclrVertaal.instant('beschaarheid.' + translationItem.translationKey.toLowerCase() + '.edit.uitleg'),
                                    }
                                    DoclrModalService.openEditModal(
                                        '/partials/beschikbaarheidtypes/beschikbaarheide.mailtext.edit.modal.html',
                                        {
                                            backdrop: 'static',
                                            modalSize: 'lg',
                                            model: translationItemClone,
                                            defaultProductId: $scope.type.ipdcProductId
                                        })
                                        .then(() => _onApplyTranslationText(translationItemClone), () => {
                                        });

                                }

                                function _onApplyTranslationText(translationItem) {

                                    var updatedTranslationItem = translationItem.value ? JSON.stringify(translationItem.value) : undefined;

                                    EditableBeschikbaarheidTypes.saveTranslationItem(type, translationItem.language, updatedTranslationItem, translationItem.translationKey)
                                        .then(() => {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.' + translationItem.translationKey + '.udated'));

                                            let translationItems = $scope.translationKeys[translationItem.translationKey];

                                            for (let i = 0; i < translationItems.length; i++) {
                                                if (translationItems[i].language === translationItem.language) {
                                                    translationItems[i].value = translationItem.value;
                                                    if (translationItem.value) {
                                                        translationItems[i].hasTranslation = translationItem.value.rawHtml && translationItem.value.rawHtml.trim() !== '';
                                                        translationItems[i].toolTipValue = $sce.trustAsHtml(getTooltipValue(translationItem.value.rawHtml, translationItem.translationKey));
                                                    } else {
                                                        translationItems[i].hasTranslation = false;
                                                        translationItems[i].toolTipValue = $sce.trustAsHtml(getTooltipValue(undefined, translationItem.translationKey));
                                                    }
                                                }
                                            }
                                        });

                                }


                                type.mailOntvangers = mailOntvangers;

                                $scope.bewaren = function () {
                                    if (!$scope.isNieuwType()) {
                                        EditableBeschikbaarheidTypes.saveWijzigingen(type).then(function () {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeUdated'));
                                            $scope.goToDetail(type.id);
                                        });
                                    } else {
                                        EditableBeschikbaarheidTypes.saveNieuwType(praktijkContext.id, type).then(function (nieuweType) {
                                            notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeCreated'));
                                            $scope.goToDetail(nieuweType.id);
                                        });
                                    }
                                };

                                $scope.verwijderen = function () {
                                    $scope.confirmmodal = {
                                        title: doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.deleteTypeTitle'),
                                        question: doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.deleteTypeQuestion', {name: type.naam})
                                    };

                                    var modalInstance = $uibModal.open({
                                        templateUrl: '/partials/components/confirmmodal.html',
                                        scope: $scope
                                    });

                                    modalInstance.result.then(function () {
                                        EditableBeschikbaarheidTypes.verwijder(type).then(
                                            function () {
                                                notificationService.showSuccess(doclrVertaal.instant('partials.beschikbaarheidtypes.beschikbaarheidtypes.detail.messageTypeDeleted'));
                                                $state.go('activiteiten', {typeId: null});
                                            }
                                        );
                                    });
                                };

                                $scope.reload = function () {
                                    $scope.goToDetail($scope.type.id);
                                };
                            }
                        }
                    }

                });
        });
})();